/**
 * 공용 차트 시각 계약 경계.
 *
 * Owns:
 * - 제품 화면들이 함께 쓰는 grid·axis·tooltip chrome.
 * - 테마별 categorical series 슬롯의 안정적인 순서.
 *
 * Does not own:
 * - feature별 차트 크기·마크 기하·데이터 의미.
 * - Evaluation 전용 라벨·이상치 표현.
 */
export const CHART_CHROME = {
  grid: "var(--c6-color-border-subtle)",
  axis: "var(--c6-color-text-muted)",
  tooltipBg: "var(--c6-color-bg-surface)",
  tooltipBorder: "var(--c6-color-border-subtle)",
  // recharts 기본 툴팁 글자는 시리즈 fill·stroke를 따른다. 그래서 `Cell`만 칠한 막대에서는
  // 검정이 될 수 있다. 툴팁 글자는 데이터 채널이 아니므로 공용 본문 글자색으로 고정한다.
  tooltipInk: "var(--c6-color-text-default)",
} as const;

// CSS 변수를 참조해야 테마 전환 시 차트와 범례가 같은 프레임에서 함께 바뀐다.
export const CHART_SERIES_PALETTE = [
  "var(--app-chart-series-slot-0)",
  "var(--app-chart-series-slot-1)",
  "var(--app-chart-series-slot-2)",
  "var(--app-chart-series-slot-3)",
  "var(--app-chart-series-slot-4)",
  "var(--app-chart-series-slot-5)",
  "var(--app-chart-series-slot-6)",
  "var(--app-chart-series-slot-7)",
  "var(--app-chart-series-slot-8)",
  "var(--app-chart-series-slot-9)",
  "var(--app-chart-series-slot-10)",
  "var(--app-chart-series-slot-11)",
  "var(--app-chart-series-slot-12)",
  "var(--app-chart-series-slot-13)",
  "var(--app-chart-series-slot-14)",
] as const;

/** 기존 id의 슬롯을 보존하고 새 id에는 가장 낮은 빈 슬롯을 배정한다. */
export function assignChartSeriesSlots(
  ids: readonly string[],
  previous: Readonly<Record<string, number>>,
): Record<string, number> {
  const next: Record<string, number> = {};
  const used = new Set<number>();
  for (const id of ids) {
    const slot = previous[id];
    if (slot !== undefined && !used.has(slot)) {
      next[id] = slot;
      used.add(slot);
    }
  }
  for (const id of ids) {
    if (next[id] !== undefined) continue;
    let slot = 0;
    while (used.has(slot)) slot += 1;
    next[id] = slot;
    used.add(slot);
  }
  return next;
}
